import * as React from 'react'

import { Icon } from '~/components/icon/Icon'
import { styled } from '~/styled'

const StyledNavigationMenuVerticalIcon = styled(Icon, {
  base: ['self-start']
})

export const NavigationMenuVerticalIcon = (
  props: React.ComponentProps<typeof StyledNavigationMenuVerticalIcon>
): React.JSX.Element => (
  <StyledNavigationMenuVerticalIcon size="md" {...props} />
)
